export const AUTH = {
  loginEmailInput: 'auth-login-email-input',
  loginPasswordInput: 'auth-login-password-input',
  loginSubmitButton: 'auth-login-submit-button',
  registerEmailInput: 'auth-register-email-input',
  registerPasswordInput: 'auth-register-password-input',
  registerNameInput: 'auth-register-name-input',
  registerSubmitButton: 'auth-register-submit-button',
  logoutButton: 'auth-logout-button'
};

export const DASHBOARD = {
  adminDashboard: 'admin-dashboard',
  providerDashboard: 'provider-dashboard',
  clientDashboard: 'client-dashboard',
  statsCard: 'dashboard-stats-card',
  alertsSection: 'dashboard-alerts-section'
};

export const PROVIDER = {
  verificationForm: 'provider-verification-form',
  verificationSubmitButton: 'provider-verification-submit-button',
  profileCard: 'provider-profile-card',
  reviewItem: 'provider-review-item'
};

export const ADMIN = {
  approveButton: 'admin-approve-button',
  rejectButton: 'admin-reject-button',
  verificationsList: 'admin-verifications-list',
  settingsForm: 'admin-settings-form'
};

export const HOME = {
  emergentLink: 'home-emergent-link',
  getStartedButton: 'home-get-started-button',
  loginLink: 'home-login-link'
};
